<!--
 * @Author: 'llhj' llhj0326@163.com
 * @Date: 2024-04-23 16:00:32
 * @LastEditors: 'llhj' llhj0326@163.com
 * @LastEditTime: 2024-04-30 14:58:50
 * @FilePath: \front\src\views\System\myData.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
     <div>		
		<div class="pg-header">
            <div>
				<label class="title">软件信息</label>
			</div>
			<div class="algr">
				<div class="pg-nav">
					<i class="icon-home"></i>
					<span>系统管理</span>|
					<span>数据管理</span>|
					<span class="active">软件信息</span>
				</div>
			</div>
        </div>
		<div class="table-wrap">
            <div class="content">
                <h1>基本信息</h1>
                <p>医院名称：{{ hospitalName}}</p>
                <p>
                    <span>授权有效期至：{{ mydata.expirationTime }}</span>
                    <span style="margin-left: 30px;">剩余天数：{{ mydata.day }}天</span>
                </p>
            </div>
            <div class="content">
                <h1>服务支持</h1>
                <p style="color:#FF6C6C" >授权即将到期，请联系双佰康疾病管理工程师。</p>
            </div>
            <div class="content">
                <h1>产品信息</h1>
                <p>版本号：{{ hospitalVersion }}</p>
                <p>厂商名称：健生来康（北京）科技有限公司</p>
            </div>
        </div>
    </div>
</template>

<script>
import api from '@/service/api.js';

export default {
    data() {
        return {
            hospitalName:'',
            hospitalVersion:'',
            mydata:{}
        }
    },
    mounted() {
        api.getHospitalName().then(res=>{
            this.hospitalName = res
        })
        api.getHospitalVersion().then(res=>{

            this.hospitalVersion = res
        })
        api.getMyData().then(res=>{
            this.mydata = res.data
        })
    },
}
</script>

<style lang="less" scoped>
@import '@/assets/style/var';
.table-wrap {
    padding: 1px 34px 34px;
    .content{
        h1{
            font-size: 20px;
        }
        p{
            font-size: 16px;
        }
    }
}
</style>
